import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { Trans } from "@coworker/locales";
import React, { Dispatch, SetStateAction } from "react";
import ArrowLeftArrowRightIconPath from "@ingka/ssr-icon/paths/arrow-left-arrow-right";
import styles from "../swipeable-testbuy-list-view-item.module.css";

interface GetNewButtonProps {
  onClick: () => void;
  swipeDirection: string;
  setSwipeDirection: Dispatch<SetStateAction<"" | "left" | "right">>;
}

export const GetNewButton = ({
  onClick,
  swipeDirection,
  setSwipeDirection,
}: GetNewButtonProps) => {
  const handleClickWrapper = () => {
    setSwipeDirection("");
    onClick();
  };
  const combinedClassName = `${styles["button-get-new"]} ${styles["button-get-new-color"]}`;

  return (
    <div
      className={`${combinedClassName} ${
        swipeDirection === "left"
          ? styles["button-hidden"]
          : styles["button-get-new-visible"]
      }`}
      onClick={handleClickWrapper}
      role={"button"}
    >
      <FixaSSRIcon paths={ArrowLeftArrowRightIconPath} />
      <span className={styles["button-text"]}>
        <Trans>getNewString</Trans>
      </span>
    </div>
  );
};
